function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9zdG9wd2F0Y2guanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2ljb25zL3N0b3B3YXRjaC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gU3RvcHdhdGNoKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE2IDI0Yy00LjQxMSAwLTgtMy41ODktOC04IDAtNC40MTIgMy41ODktOCA4LThzOCAzLjU4OCA4IDhjMCA0LjQxMS0zLjU4OSA4LTggOG0wLTE4QzEwLjQ3OCA2IDYgMTAuNDc3IDYgMTZjMCA1LjUyMiA0LjQ3OCAxMCAxMCAxMHMxMC00LjQ3OCAxMC0xMGMwLTUuNTIzLTQuNDc4LTEwLTEwLTEwbTEwLjcwNyAyLjI5M2wtNC00YS45OTkuOTk5IDAgMTAtMS40MTQgMS40MTRsNCA0YS45OTcuOTk3IDAgMDAxLjQxNCAwIC45OTkuOTk5IDAgMDAwLTEuNDE0TTE3IDE1LjU4NlYxMWExIDEgMCAxMC0yIDB2NWMwIC4xMy4wMjYuMjYuMDc3LjM4MmEuOTkuOTkgMCAwMC4yMTcuMzI2bDMuNTM0IDMuNTM0YS45OTMuOTkzIDAgMDAuNzA3LjI5My45OTkuOTk5IDAgMDAuNzA3LTEuNzA3TDE3IDE1LjU4NnpNNi43MDcgOS43MDdsNC00YS45OTkuOTk5IDAgMTAtMS40MTQtMS40MTRsLTQgNGEuOTk5Ljk5OSAwIDEwMS40MTQgMS40MTRcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5TdG9wd2F0Y2gucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBTdG9wd2F0Y2g7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Stopwatch(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M16 24c-4.411 0-8-3.589-8-8 0-4.412 3.589-8 8-8s8 3.588 8 8c0 4.411-3.589 8-8 8m0-18C10.478 6 6 10.477 6 16c0 5.522 4.478 10 10 10s10-4.478 10-10c0-5.523-4.478-10-10-10m10.707 2.293l-4-4a.999.999 0 10-1.414 1.414l4 4a.997.997 0 001.414 0 .999.999 0 000-1.414M17 15.586V11a1 1 0 10-2 0v5c0 .13.026.26.077.382a.99.99 0 00.217.326l3.534 3.534a.993.993 0 00.707.293.999.999 0 00.707-1.707L17 15.586zM6.707 9.707l4-4a.999.999 0 10-1.414-1.414l-4 4a.999.999 0 101.414 1.414",
    fill: primaryColor
  }));
}

Stopwatch.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Stopwatch;